// @ts-strict-ignore
import { Environment } from '@/types';
import { isEmpty } from 'lodash';

export enum EventName {
    SignUp = 'sign_up',
    Login = 'login',
    Conversion = 'conversion',
}

export enum SignUpLoginMethod {
    EmailPassword = 'email-password',
    GitHub = 'github',
    Google = 'google',
    Saml = 'sso-saml',
}

export interface GAUserProperties {
    userId: string;
    orgId: string;
}

const defaultProperties = () => {
    return {
        hostname: window.location.hostname,
    };
};

/*
    Updates the GA configuration
*/

export const config: (
    measurementId: string,
    params: Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams,
) => void = (measurementId, params) => {
    const defaultProps = defaultProperties();

    if (window == undefined || window.gtag == undefined) return;

    window.gtag('config', measurementId, {
        ...defaultProps,
        ...params,
    });
};

/*
    Triggers a pageview
*/

export const pageview: () => void = () => {
    if (window == undefined) return;

    // initialize gtag if not already present
    // extracted from Google's documentation: https://developers.google.com/tag-platform/gtagjs
    if (typeof gtag == 'undefined') {
        log('Initializing gtag');
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
    }

    log('Tracking Google Analytics page view event');

    window.gtag('event', 'page_view');
};

const log = (message: string) => {
    if (process.env.NODE_ENV !== Environment.Production) {
        console.log(message);
    }
};

/*
    Triggers an event
*/

export const track: (
    eventName: string | Gtag.EventNames,
    extraParams?: Gtag.CustomParams,
    userProperties?: GAUserProperties,
) => void = (eventName, extraParams = null, userProperties = null) => {
    const params =
        extraParams ?
            {
                ...extraParams,
            }
        :   {};

    if (userProperties) {
        params['user_id'] = userProperties.userId;
        params['org_id'] = userProperties.orgId;
    }

    if (window == undefined || window.gtag == undefined) return;

    if (!isEmpty(params)) {
        window.gtag('event', eventName, params);
    } else {
        window.gtag('event', eventName);
    }
};

/*
    Sets paramaters on all future events
*/

export const set: (params: Gtag.CustomParams) => void = (params: Gtag.CustomParams) => {
    window.gtag('set', params);
};
